export default __webpack_public_path__ + "static/media/normal-lineChart-icon.4cc678be.svg";